// extracted by mini-css-extract-plugin
module.exports = {"qrcodeWrap":"style_qrcodeWrap__1n6VP"};